<template>
  <div>
    <Header></Header>

    <v-layout
      style="margin-bottom: 8rem"
      wrap
      class="mt-12 justify-center"
      :style="$vuetify.breakpoint.smAndDown ? { 'margin-bottom': '14rem' } : ''"
    >
      <v-flex lg4 md5 sm12 px-4>
        <v-card flat>
          <v-form
            style="background-color: #fff;"
            class="pa-lg-12 pa-md-12 pa-sm-12 pa-6"
            ref="form"
            v-model="valid"
            :lazy-validation="lazy"
          >
            <!-- Title  -->
            <v-layout justify-space-between mb-5>
              <v-flex shrink>
                <div class="txt-large">{{ $t("login") }}</div>
                <div>To CONNECT by CEA</div>
              </v-flex>
            </v-layout>
            <span class="font-weight-bold">{{ $t("email") }}</span>
            <v-text-field
              background-color="#E5E5E5"
              dense
              solo
              flat
              v-model="email"
              class="mt-2 radius8"
              required
              :rules="emailRules"
            ></v-text-field>

            <span class="font-weight-bold">{{ $t("password") }}</span>
            <v-text-field
              background-color="#E5E5E5"
              dense
              solo
              flat
              type="password"
              v-model="password"
              class="mt-2 radius8"
              :rules="requireRules"
              @keyup.enter="login"
            ></v-text-field>

            <v-checkbox
              :label="$t('remember-me')"
              v-model="remember_me"
            ></v-checkbox>

            <v-btn
              v-if="valid"
              dark
              class="my-5"
              block
              depressed
              color="#FD5246"
              @click="login"
              >{{ $t("login") }}
            </v-btn>
            <v-btn
              v-else
              depressed
              width="150"
              dark
              color="#C5C5C5"
              class="my-5"
              block
            >
              {{ $t("login") }}
            </v-btn>
            <v-layout justify-center>
              <v-flex shrink mx-5 text-center>{{ $t("or") }}</v-flex>
            </v-layout>
            <v-btn
              class="my-5"
              block
              depressed
              color="#1877F2"
              style="position: relative"
              dark
              @click="logInWithFacebook"
            >
              <v-layout class="justify-center">
                <v-spacer></v-spacer>
                <v-flex shrink mx-3 class="d-flex justify-center align-center">
                  <img
                    width="25px"
                    :src="require('../assets/facebook icon.png')"
                  />
                </v-flex>
                <v-flex shrink class="d-flex justify-center align-center">
                  {{ $t("login-facebook") }}
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
            </v-btn>

            <div class="my-5 text-center">
              <span class="forgotpass" @click="forgotPassword"
                >{{ $t("forgot-password") }} ?</span
              >
            </div>
          </v-form>
        </v-card>
      </v-flex>

      <v-flex
        lg4
        md5
        sm12
        :style="
          $vuetify.breakpoint.mdAndUp
            ? 'height: calc(100vh - 75px)'
            : 'height: 100%'
        "
      >
        <v-layout
          class="px-lg-12 px-md-12 px-6 pt-12 d-flex align-center justify-center"
        >
          <v-flex xs12>
            <v-layout>
              <v-flex>
                <div class="txt-large mb-3">{{ $t("register") }}</div>
                <p>
                  CONNECT by CEA คือ
                  เว็บไซต์ที่รวบรวมรายชื่อนักออกแบบไทยในสาขาต่างๆ
                  ตลอดจนผู้ให้บริการที่เกี่ยวข้องกับการพัฒนาผลิตภัณฑ์
                  เพื่ออำนวยความสะดวกให้กับนักออกแบบและผู้ประกอบการไทยใช้ในการพัฒนาธุรกิจของตนเอง
                  สามารถอัพโหลดผลงานของคุณง่ายๆ ได้ผ่านช่องทางโซเชียลมีเดียต่างๆ
                  ได้ทันที
                </p>
              </v-flex>
            </v-layout>

            <v-layout mt-3>
              <v-flex flex-start>
                <v-btn
                  color="#FD5246"
                  large
                  outlined
                  dark
                  width="160"
                  @click="$router.push('/register')"
                >
                  {{ $t("register") }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <Footer id="footer"></Footer>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "LoginTemp",
  components: {
    Header,
    Loading,
    Footer,
  },
  data: () => ({
    valid: true,
    lazy: false,
    isLoading: false,
    fullPage: true,
    email: "",
    password: "",
    remember_me: false,
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    requireRules: [(v) => !!v || "The Field is required"],
    image_profile_facebook: null,
  }),
  async mounted() {
    await this.loadFacebookSDK(document, "script", "facebook-jssdk");
    await this.initFacebook(window);
  },
  async created() {
    // await this.loadFacebookSDK(document, "script", "facebook-jssdk");
    // await this.initFacebook(window);
  },
  methods: {
    // Login Facebook ----> https://medium.com/@mrjohnkilonzi/a-simple-facebook-login-component-in-vue-js-5ee71997bb97
    async logInWithFacebook() {
      let _this = this;
      window.FB.login(
        function(response) {
          _this.isLoading = true;
          if (response.authResponse) {
            var accessToken = response.authResponse.accessToken;
            // Set accessToken FB
            _this.$store.commit("auth/setAccessTokenFB", accessToken);

            // Login facebook
            window.FB.api(
              "/me",
              "get",
              {
                fields:
                  "id,name,email,first_name,last_name,picture.width(150).height(150)",
              },
              function(response) {
                // Insert your code here
                let data = {
                  fb_id: response.id,
                  email: response.email,
                  firstname_th: response.first_name,
                  lastname_th: response.last_name,
                  image_profile_facebook: response.picture.data.url,
                };
                _this.$store
                  .dispatch("auth/login_facebook", data)
                  .then(() => {
                    _this.isLoading = false;
                    _this.$router.push("/homepage");
                  })
                  .catch((e) => {
                    if (e.response.data.status === 409) {
                      _this.$swal({
                        icon: "error",
                        title: "ไม่สามารถเข้าสู่ระบบได้",
                        text:
                          " เนื่องจาก email facebook นี้ มีอยู่ในระบบอยู่แล้ว",
                        confirmButtonColor: "#FD5246",
                        confirmButtonText: "ตกลง",
                      });
                      console.log("error!!!", e.response.data.message);
                    }
                    _this.isLoading = false;
                  });
              }
            );
          } else {
            _this.isLoading = false;
            console.log("User cancelled login or did not fully authorize.");
          }
        },
        { scope: ["email", "user_photos"] }
      );
      this.isLoading = false;
      return false;
    },
    async initFacebook(_window) {
      _window.fbAsyncInit = function() {
        _window.FB.init({
          appId: "806762203217212", //You will need to change this
          cookie: true, // This is important, it's not enabled by default
          version: "v7.0",
        });
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },

    forgotPassword() {
      this.$router.push("/forgot");
    },
    login() {
      if (this.email && this.password) {
        let data = {
          email: this.email,
          password: this.password,
          remember_me: this.remember_me,
        };
        this.isLoading = true;
        this.$store.dispatch("auth/login", data).then((res) => {
          this.isLoading = false;
          switch (res.status) {
            case 200:
              this.$router.push("/homepage");
              break;
            case 401:
              this.$swal({
                icon: "error",
                text: res.message,
                confirmButtonColor: "#FD5246",
                confirmButtonText: "ตกลง",
              });
              break;
            case 403:
              this.$swal({
                icon: "error",
                text: res.message,
                confirmButtonColor: "#FD5246",
                confirmButtonText: "ตกลง",
              });
              break;
            case 404:
              this.$swal({
                icon: "error",
                text: res.message,
                confirmButtonColor: "#FD5246",
                confirmButtonText: "ตกลง",
              });
              break;
          }
        });
      } else {
        this.isLoading = false;
        this.$swal({
          icon: "error",
          text: "กรุณากรอก email และ password",
          confirmButtonColor: "#FD5246",
          confirmButtonText: "ตกลง",
        });
      }
    },
  },
};
</script>

<style scoped>
.register-info {
  color: #fff;
}

.gray-layer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
}

.divider-login {
  border: solid 1px #c4c4c4;
}

.forgotpass {
  text-decoration: underline;
  color: #fd5246;
  cursor: pointer;
}

.detail-info {
  text-indent: 25px;
}

/*Auth Facebook*/
.information {
  margin-top: 100px;
  margin: auto;
  display: flex;
  flex-direction: column;
}

.well {
  background-color: rgb(191, 238, 229);
  margin: auto;
  padding: 50px 50px;
  border-radius: 20px;
  /* display:inline-block; */
}

.login {
  width: 200px;
  margin: auto;
}

.list-item:first-child {
  margin: 0;
}

.list-item {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.button {
  margin: auto;
}
</style>
